/*
 * @Description: 动态字段配置信息
 * @Author: shenah
 * @Date: 2023-04-28 17:13:48
 * @LastEditors: shenah
 * @LastEditTime: 2023-11-07 10:39:43
 */

import { createWholeConfig } from "_dataview/output/config/scrollDigital";
import { createPrefixSuffixRuleConfig } from "./prefixSuffixRuleConfig";

// 柱体配置
export const createBarConfig = () => ({
  minPercent: undefined, // 最小百分比
  width: "100", // 柱体宽度
  height: "10", // 柱体高度
  borderRadius: "4", // 边框圆角
  bgColor: "#37a2da", // 颜色
  basicBgColor: "#DCE3F3", // 底色
  showValue: false,
  isGradient: false,
  gradientColors: ["#37a2da", "#37a2da"],
  bgColorRule: {
    ...createPrefixSuffixRuleConfig(false),
    hideDefault: true,
  },
});

export const createOneExpendStyle = () => {
  let digitalWholeConfig = createWholeConfig();
  digitalWholeConfig.config.autoplay = false;
  digitalWholeConfig.fontPadding = [0, 0, 0, 0];
  let obj = {
    nameFontSize: "",
    nameFontFamily: "Microsoft Yahei",
    nameBoldFlag: false,
    nameColor: "",
    valueFontFamily: "Microsoft Yahei",
    valueFontSize: "",
    valueBoldFlag: false,
    valueColor: "",
    unitFontFamily: "Microsoft Yahei",
    unitFontSize: "",
    unitBoldFlag: false,
    unitColor: "",
    align: "flex-start",
    verticalAlign: "center",
    valueMarginTop: 0,
    valueMarginRight: 0,
    valueMarginBottom: 0,
    valueMarginLeft: 10,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    relativeTop: 0,
    relativeRight: 0,
    relativeBottom: 0,
    relativeLeft: 0,
    lineNum: 0,
    height: "auto",
    lineHeight: "normal",
    //数字翻牌器配置
    digitalWholeConfig,
    //值单位换算配置
    valueUnitTransform: "",
    // 值是否走规则
    valueToRuleFlag: true,
    // 单位是否走规则
    unitToRuleFlag: false,
    // 是否是柱体
    isBar: false,
    // 柱体配置
    barConfig: createBarConfig(),
  };
  digitalWholeConfig.fontSize = obj.valueFontSize;
  digitalWholeConfig.color = obj.valueColor;
  digitalWholeConfig.isFontBold = obj.valueBoldFlag;
  return obj;
};
